(function () {
  const STORAGE_KEY = 'silkie_wishlist';

  function getWishlist() {
    try {
      const storedValue = localStorage.getItem(STORAGE_KEY);

      if (!storedValue) {
        return [];
      }

      const wishlist = JSON.parse(storedValue);

      return Array.isArray(wishlist) ? wishlist : [];
    } catch (error) {
      console.error('Unable to read wishlist:', error);
      return [];
    }
  }

  function saveWishlist(wishlist) {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(wishlist)
      );

      document.dispatchEvent(
        new CustomEvent('silkie:wishlist-updated', {
          detail: {
            wishlist: wishlist,
            count: wishlist.length
          }
        })
      );
    } catch (error) {
      console.error('Unable to save wishlist:', error);
    }
  }

  function getCardVariantId(card) {
    const variantInput = card.querySelector(
      '[data-fpv2-form] input[name="id"]'
    );

    if (!variantInput || !variantInput.value) {
      return null;
    }

    return String(variantInput.value);
  }

  function getCardVariants(card) {
    const variantsScript = card.querySelector(
      '[data-fpv2-variants]'
    );

    if (!variantsScript) {
      return [];
    }

    try {
      const variants = JSON.parse(
        variantsScript.textContent
      );

      return Array.isArray(variants) ? variants : [];
    } catch (error) {
      console.error(
        'Unable to parse product variants:',
        error
      );

      return [];
    }
  }

  function getSelectedVariant(card) {
    const variantId = getCardVariantId(card);
    const variants = getCardVariants(card);

    return variants.find(function (variant) {
      return String(variant.id) === variantId;
    }) || null;
  }

  function getProductHandle(productUrl) {
    try {
      const url = new URL(
        productUrl,
        window.location.origin
      );

      const match = url.pathname.match(
        /\/products\/([^/?#]+)/
      );

      return match ? match[1] : '';
    } catch (error) {
      return '';
    }
  }

  function getCardProduct(card) {
    const variantId = getCardVariantId(card);
    const selectedVariant = getSelectedVariant(card);

    const titleLink = card.querySelector(
      '.fpv2-title'
    );

    const imageLink = card.querySelector(
      '.fpv2-image-link'
    );

    const mainImage = card.querySelector(
      '.fpv2-image--main'
    );

    const priceElement =
      card.querySelector(
        '[data-fpv2-price]:not(.hidden)'
      ) ||
      card.querySelector(
        '[data-fpv2-price]'
      );

    const productUrl =
      titleLink?.getAttribute('href') ||
      imageLink?.getAttribute('href') ||
      '';

    const handle = getProductHandle(productUrl);

    if (!variantId || !handle) {
      return null;
    }

    const normalizedUrl = new URL(
      '/products/' + handle,
      window.location.origin
    );

    normalizedUrl.searchParams.set(
      'variant',
      variantId
    );

    return {
      productId: '',
      variantId: variantId,
      handle: handle,
      title: titleLink
        ? titleLink.textContent.trim()
        : '',
      variantTitle: '',
      vendor: '',
      price: null,
      formattedPrice: priceElement
        ? priceElement.textContent.trim()
        : '',
      available: selectedVariant
        ? Boolean(selectedVariant.available)
        : true,
      image: selectedVariant?.image ||
        mainImage?.currentSrc ||
        mainImage?.src ||
        '',
      url:
        normalizedUrl.pathname +
        normalizedUrl.search,
      addedAt: new Date().toISOString()
    };
  }

  function isVariantInWishlist(variantId) {
    if (!variantId) {
      return false;
    }

    return getWishlist().some(function (item) {
      return (
        String(item.variantId) ===
        String(variantId)
      );
    });
  }

  function updateHeart(card) {
    const heart = card.querySelector(
      '.fpv2-wishlist'
    );

    if (!heart) {
      return;
    }

    const variantId = getCardVariantId(card);
    const isAdded = isVariantInWishlist(variantId);

    const svg = heart.querySelector('svg');

    heart.classList.toggle(
      'is-added',
      isAdded
    );

    heart.setAttribute(
      'aria-label',
      isAdded
        ? 'Remove from Wishlist'
        : 'Add to Wishlist'
    );

    heart.setAttribute(
      'title',
      isAdded
        ? 'Remove from Wishlist'
        : 'Add to Wishlist'
    );

    heart.setAttribute(
      'aria-pressed',
      isAdded ? 'true' : 'false'
    );

    if (svg) {
      svg.setAttribute(
        'fill',
        isAdded ? 'currentColor' : 'none'
      );
    }
  }

  function updateAllHearts() {
    document
      .querySelectorAll('[data-fpv2-card]')
      .forEach(function (card) {
        updateHeart(card);
      });
  }

  function toggleWishlist(card) {
    const product = getCardProduct(card);

    if (!product) {
      console.error(
        'Unable to retrieve product information.'
      );
      return;
    }

    let wishlist = getWishlist();

    const existingIndex = wishlist.findIndex(
      function (item) {
        return (
          String(item.variantId) ===
          String(product.variantId)
        );
      }
    );

    if (existingIndex !== -1) {
      const removedItem = wishlist[existingIndex];

      wishlist.splice(existingIndex, 1);
      saveWishlist(wishlist);

      document.dispatchEvent(
        new CustomEvent(
          'silkie:wishlist-removed',
          {
            detail: removedItem
          }
        )
      );
    } else {
      wishlist.push(product);
      saveWishlist(wishlist);

      document.dispatchEvent(
        new CustomEvent(
          'silkie:wishlist-added',
          {
            detail: product
          }
        )
      );
    }

    updateAllHearts();
  }

  function initializeHearts() {
    document
      .querySelectorAll(
        '[data-fpv2-card] .fpv2-wishlist'
      )
      .forEach(function (heart) {
        /*
         * Ces attributs sont ajoutés par JavaScript :
         * aucune modification Liquid n’est nécessaire.
         */
        heart.removeAttribute('aria-hidden');
        heart.setAttribute('role', 'button');
        heart.setAttribute('tabindex', '0');
      });

    updateAllHearts();
  }

  /*
   * Clic sur le cœur.
   */
  document.addEventListener(
    'click',
    function (event) {
      const heart = event.target.closest(
        '.fpv2-wishlist'
      );

      if (!heart) {
        return;
      }

      const card = heart.closest(
        '[data-fpv2-card]'
      );

      if (!card) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      toggleWishlist(card);
    }
  );

  /*
   * Accessibilité clavier.
   */
  document.addEventListener(
    'keydown',
    function (event) {
      const heart = event.target.closest(
        '.fpv2-wishlist'
      );

      if (
        !heart ||
        (
          event.key !== 'Enter' &&
          event.key !== ' '
        )
      ) {
        return;
      }

      const card = heart.closest(
        '[data-fpv2-card]'
      );

      if (!card) {
        return;
      }

      event.preventDefault();
      toggleWishlist(card);
    }
  );

  /*
   * Après un clic sur une couleur, le code existant de
   * votre grille change normalement l’input variant.
   * Le cœur est ensuite actualisé pour cette variante.
   */
  document.addEventListener(
    'click',
    function (event) {
      const swatch = event.target.closest(
        '[data-fpv2-swatch]'
      );

      if (!swatch) {
        return;
      }

      const card = swatch.closest(
        '[data-fpv2-card]'
      );

      if (!card) {
        return;
      }

      window.setTimeout(function () {
        updateHeart(card);
      }, 50);
    }
  );

  /*
   * Synchronisation entre plusieurs onglets.
   */
  window.addEventListener(
    'storage',
    function (event) {
      if (event.key === STORAGE_KEY) {
        updateAllHearts();
      }
    }
  );

  /*
   * Support des produits chargés dynamiquement
   * par pagination Ajax ou infinite scroll.
   */
  const observer = new MutationObserver(
    function (mutations) {
      let hasNewCards = false;

      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(
          function (node) {
            if (!(node instanceof HTMLElement)) {
              return;
            }

            if (
              node.matches?.('[data-fpv2-card]') ||
              node.querySelector?.('[data-fpv2-card]')
            ) {
              hasNewCards = true;
            }
          }
        );
      });

      if (hasNewCards) {
        initializeHearts();
      }
    }
  );

  function startWishlist() {
    initializeHearts();

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startWishlist
    );
  } else {
    startWishlist();
  }
})();